// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Lp-z","imageAndVideoCount":"Mp-z","imageAndVideoContainer":"Np-z","viewAllReviews":"Op-z"};